import React from "react";

const CustomHeaderMont = ({ label }) => {
  return <div className="rbc-month-label text-truncate">{label}</div>;
};

export default CustomHeaderMont;
